import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const CheckedCircleIcon = (props: IconProps) => (
  <Icon w="32px" h="32px" viewBox="0 0 32 32" {...props}>
    <circle cx="16" cy="16" r="16" />
    <path
      d="M13 20.1698L8.83003 15.9998L7.41003 17.4098L13 22.9998L25 10.9998L23.59 9.58984L13 20.1698Z"
      fill="#fff"
    />
  </Icon>
);

export default memo(CheckedCircleIcon);
